import * as Yup from "yup";


// Domain for the default SOCIETY_ADMIN login created with the society. Mirrors
// the API rule: at least one dot, no spaces, no "@", max 253 chars.
const DOMAIN_REGEX = /^(?=.{1,253}$)[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i;

// Trim, drop a leading "@" and lower-case — what the server stores anyway.
export const normaliseEmailDomain = (value) =>
    String(value ?? '').trim().replace(/^@+/, '').toLowerCase();

export const addCommunitySchema = ({ isEdit = false } = {}) => {
    return Yup.object().shape({
        // Only used when the admin is first created — PATCH does not accept it.
        admin_email_domain: isEdit
            ? Yup.string().notRequired()
            : Yup
                .string()
                .transform((v) => normaliseEmailDomain(v))
                .required("Admin email domain is required")
                .test('no-at', "Enter only the domain, without @ (e.g. greenvalley.com)", (v) => !v || !v.includes('@'))
                .matches(DOMAIN_REGEX, "Enter a valid domain, e.g. greenvalley.com"),

        name: Yup
            .string()
            .required(" Community Name is required")
            .min(3, "Community Name must be at least 3 characters"),

        type: Yup
            .string()
            .required("Please select a type"),

        registration_number: Yup
            .string()
            .required("Registration number is required")
            .matches(/^[a-zA-Z0-9]+$/, "Registration number must be alphanumeric"),

        registration_authority: Yup
            .string()
            .required("Registration authority is required"),

        // ---- Geofence (employee attendance) — all optional ----
        // A society is only geofenced when enabled AND a center + radius are set.
        geofence_latitude: Yup
            .number()
            .nullable()
            .transform((v, o) => (o === '' || o === null ? null : v))
            .typeError("Latitude must be a number")
            .min(-90, "Latitude must be between -90 and 90")
            .max(90, "Latitude must be between -90 and 90"),

        geofence_longitude: Yup
            .number()
            .nullable()
            .transform((v, o) => (o === '' || o === null ? null : v))
            .typeError("Longitude must be a number")
            .min(-180, "Longitude must be between -180 and 180")
            .max(180, "Longitude must be between -180 and 180"),

        geofence_radius_meters: Yup
            .number()
            .nullable()
            .transform((v, o) => (o === '' || o === null ? null : v))
            .typeError("Radius must be a number")
            .min(10, "Radius must be at least 10 meters")
            .max(100000, "Radius must be at most 100000 meters"),
    });
}

export const addStatesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),

        country_id: Yup.mixed()
            .required("*Country is required"),

        state_code: Yup.string()
            .trim()
            .required("*State code is required")
            .max(3, "*State code must be at most 3 characters"),

    })
}


export const addCitiesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),
        city_code: Yup.string()
            .trim()
            .required("*City code is required")
            .max(3, "*City code must be at most 3 characters"),


        state_id: Yup.mixed()
            .required("*State is required"),

        country_id: Yup.string()
            .trim()
            .required("*Country is required")
    })
}


